<template>
  <div>
    <div>
      <div id="echartBar" />
    </div>
  </div>
</template>
<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
// require('echarts/lib/component/dataZoom')
export default {
  name: 'EchartBar',
  props: {
    newest: {
      type: Array,
      default: function() {
        return []
      }
    },
    'old': {
      type: Array,
      default: function() {
        return []
      }
    },
    barList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      echarts: null
    }
  },
  watch: {
    barList: {
      immediate: true,
      deep: true,
      handler(val) {
        this.barList = val
        if (!this.echarts) {
          return
        }
        this.init()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.echarts = echarts.init(document.getElementById('echartBar'))
      this.echarts.setOption({

        grid: {
          left: '0%', // 图表距边框的距离
          top: '15%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        // dataZoom: [{
        //   type: 'inside',
        //   moveOnMouseMove: true,
        //   zoomLock: true,
        //   start: 0,
        //   end: 90
        // }],
        xAxis: [
          {
            type: 'category',
            axisLine: {
              inside: true,
              lignWithLabel: true,
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#171717',
              fontSize: 9
            },
            data: [
              this.$t('viewBase.a84'), this.$t('viewBase.a88'), this.$t('viewBase.a89'),
              this.$t('viewBase.a85'), this.$t('viewBase.a86'), this.$t('viewBase.a87')
            ]
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              color: '#171717',
              fontSize: 9
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: this.barList
        // series: [
        //   {
        //     name: 'Forest',
        //     type: 'bar',
        //     barCategoryGap: '0%',
        //     barWidth: '20%',
        //     barGap: 0,
        //     data: this.newest[0]
        //   },
        //   {
        //     name: 'Forest',
        //     type: 'bar',
        //     barCategoryGap: '0%',
        //     barWidth: '20%',
        //     barGap: 0,
        //     data: this.newest[1]
        //   },
        //   {
        //     name: 'sece',
        //     type: 'bar',
        //     barCategoryGap: '0%',
        //     barGap: 0,
        //     barWidth: '20%',
        //     data: this.old[0]
        //   },
        //   {
        //     name: 'sece',
        //     type: 'bar',
        //     barCategoryGap: '0%',
        //     barGap: 0,
        //     barWidth: '20%',
        //     data: this.old[1]
        //   }
        // ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#echartBar{
  width: 100%;
  height:150px;
}
</style>
